import React from 'react';
import {
  Box,
  Tooltip as BaseTooltip,
  TooltipProps as BaseTooltipProps,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Typography from '@ui/Typography';

interface TooltipProps extends Omit<BaseTooltipProps, 'title'> {
  text: string | React.ReactNode;
  disabled?: boolean;
}

const useStyles = makeStyles({ name: 'Tooltip' })(theme => ({
  tooltip: {
    '& .MuiTooltip-tooltip': {
      backgroundColor: theme.palette.grey[900],
      color: theme.palette.common.white,
      borderRadius: 0,
      marginBottom: theme.spacing(0.5),
      border: `1px solid ${theme.palette.grey[800]}`,
    },
  },
}));

const Tooltip = (props: TooltipProps) => {
  const {
    children,
    classes: overrideClasses,
    text,
    disabled,
    ...restProps
  } = props;
  const { classes, cx } = useStyles();
  if (disabled) {
    return children;
  }

  let tooltipText = (
    <Box>
      <Typography variant="pSm">{text}</Typography>
    </Box>
  );

  if (typeof text !== 'string' && React.isValidElement(text)) {
    tooltipText = text;
  }

  return (
    <BaseTooltip
      placement="top-end"
      title={tooltipText}
      classes={{
        popper: cx(classes.tooltip, overrideClasses?.tooltip),
        ...overrideClasses,
      }}
      {...restProps}
    >
      {children}
    </BaseTooltip>
  );
};

export default Tooltip;
